export default "__VITE_ASSET__BMJ$769P__"